// Linear Charge Density units with conversion factors to coulomb per meter (C/m)
export const linearChargeDensityUnits = [
  { id: 'coulomb-per-meter', name: 'Coulomb/Meter', symbol: 'C/m', plural: 'Coulombs/Meter', factor: 1 },
  { id: 'coulomb-per-centimeter', name: 'Coulomb/Centimeter', symbol: 'C/cm', plural: 'Coulombs/Centimeter', factor: 100 },
  { id: 'coulomb-per-inch', name: 'Coulomb/Inch', symbol: 'C/in', plural: 'Coulombs/Inch', factor: 39.3701 },
  { id: 'microcoulomb-per-meter', name: 'Microcoulomb/Meter', symbol: 'µC/m', plural: 'Microcoulombs/Meter', factor: 1e-6 },
  { id: 'microcoulomb-per-centimeter', name: 'Microcoulomb/Centimeter', symbol: 'µC/cm', plural: 'Microcoulombs/Centimeter', factor: 1e-4 },
  { id: 'abcoulomb-per-meter', name: 'Abcoulomb/Meter', symbol: 'abC/m', plural: 'Abcoulombs/Meter', factor: 10 },
  { id: 'abcoulomb-per-centimeter', name: 'Abcoulomb/Centimeter', symbol: 'abC/cm', plural: 'Abcoulombs/Centimeter', factor: 1000 },
  { id: 'statcoulomb-per-meter', name: 'Statcoulomb/Meter', symbol: 'statC/m', plural: 'Statcoulombs/Meter', factor: 3.33564e-10 },
  { id: 'statcoulomb-per-centimeter', name: 'Statcoulomb/Centimeter', symbol: 'statC/cm', plural: 'Statcoulombs/Centimeter', factor: 3.33564e-8 },
];

export const popularLinearChargeDensityConversions = [
  { from: 'coulomb-per-meter', to: 'coulomb-per-centimeter' },
  { from: 'coulomb-per-centimeter', to: 'coulomb-per-meter' },
  { from: 'coulomb-per-meter', to: 'microcoulomb-per-meter' },
  { from: 'microcoulomb-per-meter', to: 'coulomb-per-meter' },
  { from: 'coulomb-per-meter', to: 'abcoulomb-per-meter' },
  { from: 'abcoulomb-per-meter', to: 'coulomb-per-meter' },
];

export const getUnitById = (id) => linearChargeDensityUnits.find(unit => unit.id === id);

export const convertLinearChargeDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert linear charge density units and learn the conversion formula.`;
};
